export default "__VITE_ASSET__Ysu5yG_W__"